import React, { useState } from 'react';
import { useContextTranslation } from '@core/i18n';
import { formatTimeToHHMMSS, formatTimeToSeconds } from '@core/time/formatTime';
import { useStore } from '@embed/components/VideoPlayer/Player3/store';
import { SHARE_TIMESTAMP_INPUT_FIELD } from '@player/testIds';
import { TimestampInput, TimeStampLabel, TimeStampWrapper, } from './SharePanelTimestamp.styles';
const TIMESTAMP_CHECKBOX = 'timeStampCheckbox';
const TIMESTAMP_CHECKBOX_LABEL = 'timeStampCheckboxLabel';
/**
 *
 */
export const SharePanelTimestamp = ({ initialTimeStamp, isTimeStampEnabled, onToggleTimeStampEnabled, onUpdateTimeFrameInSeconds, }) => {
    const { t } = useContextTranslation();
    const video = useStore((state) => state.video);
    const skipsTo = video?.live_stream_replay_skips_to;
    const [customTimeFrame, setCustomTimeFrame] = useState(formatTimeToHHMMSS(skipsTo ? initialTimeStamp - skipsTo : initialTimeStamp));
    return (<TimeStampWrapper>
      <input id={TIMESTAMP_CHECKBOX} aria-labelledby={TIMESTAMP_CHECKBOX_LABEL} type="checkbox" checked={isTimeStampEnabled} onChange={() => onToggleTimeStampEnabled(!isTimeStampEnabled)}/>
      <TimeStampLabel htmlFor={TIMESTAMP_CHECKBOX} id={TIMESTAMP_CHECKBOX_LABEL}>
        {t('player:Start at')}
      </TimeStampLabel>
      <TimestampInput disabled={!isTimeStampEnabled} value={customTimeFrame} data-testid={SHARE_TIMESTAMP_INPUT_FIELD} autoComplete="off" autoCapitalize="none" autoCorrect="off" onChange={(e) => setCustomTimeFrame(e.target.value)} onBlur={(e) => {
            setCustomTimeFrame(formatTimeToHHMMSS(e.target.value));
            onUpdateTimeFrameInSeconds(skipsTo
                ? formatTimeToSeconds(e.target.value) + skipsTo
                : formatTimeToSeconds(e.target.value));
        }} aria-label={t('player:Start Time')}/>
    </TimeStampWrapper>);
};
